export default __webpack_public_path__ + "static/media/SundiaryDemo-2OgdK.b3d9d4be.ttf";